import { render } from "./ProductCategoryPrefooterComponent.vue?vue&type=template&id=753db79a"
import script from "./ProductCategoryPrefooterComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryPrefooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/ProductCategoryPrefooterComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "753db79a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('753db79a', __exports__)) {
    api.reload('753db79a', __exports__)
  }
  
  module.hot.accept("./ProductCategoryPrefooterComponent.vue?vue&type=template&id=753db79a", () => {
    api.rerender('753db79a', render)
  })

}


export default __exports__